 
import { encrypt } from '../../../../commons/utils/crypto';
import {
    safariLaunchOauthPopup,
    iosChromeUpdateOauthPopupWindow,
} from '../../../../commons/utils/popup';
import { v4 as uuid } from 'uuid';
/*
 * this doesn't need to be a widget
 */

function settingsToQueryParams (s) {
    return `oauthSessionId=${s.oauthSessionId}&apiKey=${s.apiKey}&calendar=${s.selectedCalendar}&browser=${s.browser}&locale=${s.locale}`;
}

export default async function launchOauthPage () {
    const subscriberStore = this.env.subscriberStore;
    const schedulesStore = this.env.schedulesStore;
    const appStore = this.env.appStore;
    const statesStore = this.env.uiStatesStore;
    const languageStore = this.env.languageStore
    const syncStore = this.env.syncStore;
    
    let locale = appStore.locale;
    if ( appStore.widget?.language && appStore.widget?.language !== 'auto') {
        locale = appStore.widget?.language;
    }

    const settings = {
        widget: {
            ...appStore.widget,
        },
        widgetSettings: this.widgetSettings,
        selectedCalendar: statesStore.selectedCalendar,
        apiKey: this.widgetSettings.apikey,
        browser: this.userAgent.browser.name.toLowerCase(),
        translations: languageStore.translations,
        flags: appStore.flags,
        location: appStore.location,
        scheduleIds: schedulesStore.getSelectedSchedules(),
        selectedSchedules: schedulesStore.selectedSchedules,
        optins: appStore.optins,
        locale,
    };

    this.gotoOauthLauncher();
    const flags = appStore.flags;

    if (flags.safari && flags.ios && !flags.isTwitter) {
        console.log('launchOauthPage() will launch before oauthsession');
        safariLaunchOauthPopup();
    }
    await subscriberStore.initOauthSession();
    settings.oauthSessionId = this.oauthSessionId;

    const oauthqp = settingsToQueryParams(settings);
    
    console.log('generate Session () -> ')
    console.log('launchOauthPage(): sessionId is: ',  settings.oauthSessionId);
    // still save the settings with all of its data for the redirect
    this.env.setSessionSettings(settings);

    if (appStore.flags?.inAppBrowser) {
        console.log('launchOauthPage() will launch inapp browser...');
        delete settings.translations;
        const state = await this.generateInAppState();
        console.log('launchOauthPage State: ', state);
        syncStore.sync({
            ...settings,
            browser: 'inapp',
            calendar: statesStore.selectedCalendar,
            state,
        });
    }


    // get oauthSessionId before launching oauthTalking...
    if (!appStore.flags?.inAppBrowser) {
        const self = this;
        if (flags.safari && !flags.ios) {
            console.log('will launch oauth not as inAppBrowser...');
            safariLaunchOauthPopup(oauthqp);
        } else if (flags.safari && flags.ios) {
            const oauthWindow = window.open(`/oauthTalking?${oauthqp}`, 'ECAL:OAUTH_SYNCWINDOW');
            self.pollOauthWindow(oauthWindow);
        } else if (flags.chrome && flags.ios) {
            iosChromeUpdateOauthPopupWindow(appStore, oauthqp);
        } else {
            const blob = uuid();
            const oauthWindow = window.open(`/oauthTalking?${oauthqp}`, `ECAL:OAUTH_SYNCWINDOW_${blob}`);
            self.pollOauthWindow(oauthWindow);
        }
    }

    /*
    if (flags.safari && flags.ios) {
        setTimeout(() => {
            console.log('will lpost oauthSessionReady(): ');
            appStore.oauthWindow?.postMessage({ action: 'oauthSessionReady' });
        }, 1000);
    }
    */
}

export async function generateInAppState () {
    const appStore = this.env.appStore;
    const statesStore = this.env.uiStatesStore;
    const widgetSettings = appStore.widgetSettings;
    const flags = appStore.flags;
    const origin = window.location.origin;
    const apikey = widgetSettings.apikey;

    let redirectURL = `${origin}/inappredirect`;
    redirectURL = `${redirectURL}?widgetRef=${apikey}`;
    redirectURL = `${redirectURL}&apiKey=${encodeURIComponent(apikey)}`;
    redirectURL = `${redirectURL}&docReferrer=${encodeURIComponent(flags.referrer)}`;
    redirectURL = `${redirectURL}&clientOrigin=${encodeURIComponent(origin)}`;
    redirectURL = `${redirectURL}&k=${encodeURIComponent(apikey)}`;
    redirectURL = `${redirectURL}&d=APP_STORAGE`;
    
    console.log(`generateInAppState() redirectURL: ${redirectURL}`);
    const redirectTo = await encrypt(redirectURL, apikey);
    const state = {
        apiKey: widgetSettings.apikey,
        k: widgetSettings.apikey,
        sessionId: appStore.oauthSessionId,
        browser: 'inapp',
        calendar: statesStore.selectedCalendar,
        onSuccessfulAuth: 'redirect',
        redirectTo,
    };

    console.log(`generateInAppState() redirectURL: ${JSON.stringify(state)}`);

    return state;
}
